import moment from "moment";
import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Notification.scss";
import parse from "html-react-parser";

function Notification(props) {
  const cursorStyle = (item) => {
    let bool = !!item?.data?.feedbackData || !!item?.data?.cohortDiscussionData || item?.data?.type === 'new_post';
    // console.log("....bool", bool);
    return bool;
  };
  const handleNotificationClick = () => {
    if (cursorStyle(props?.nData) && props?.onNotificationClick) {
      props.onNotificationClick(props?.nData);
    }
  };
  
  const { nData, setDropDownShow, dropDownShow, showClickHere } = props;
  
  // Check if notification has clickable content
  const isClickable = cursorStyle(props?.nData);
  
  // For new post notifications, show the post title in the message area
  const getDisplayContent = () => {
    if (nData?.data?.type === 'new_post' && nData?.data?.data?.post_title) {
      return (
        <>
          <Row className="font-weight-500 html_parse_p_stlyes">
            {parse(nData?.data.message)}
          </Row>
          <Row className="mt-2">
            <Col>
              <div style={{ fontSize: "14px", fontWeight: "500" }}>
                {nData.data.data.post_title}
              </div>
            </Col>
          </Row>
        </>
      );
    }
    
    return (
      <Row className="font-weight-500 html_parse_p_stlyes">
        {parse(nData?.data.message)}
      </Row>
    );
  };
  
  return (
    <div
      className={`${
        isClickable ? "cursor-pointer" : "cursor-pointer-hidden"
      }`}
      onClick={handleNotificationClick}
    >
      <Container
        fluid
        className={
          props?.nData?.read_at?.length > 0
            ? `read_notification`
            : "unread_notification"
        }
      >
        {getDisplayContent()}
        
        <Row className="data_color">
          <Col> {moment.utc(nData?.created_at).local().fromNow()} </Col>
          <Col></Col>
          <Col></Col>
          <Col></Col>
        </Row>
        
        {/* Show plain text link at the bottom for clickable notifications */}
        {isClickable && (
          <Row className="mt-2">
            <Col>
              <div className="notification-view-text">
                Click here to view
              </div>
            </Col>
          </Row>
        )}
      </Container>
    </div>
  );
}

export default Notification;
